<template>
  <el-container class="home-page">
    <!-- 头部 -->
    <el-header class="head">
      <div class="show-box">
        <el-row style="max-width: 1080px; margin: 0 auto;">
          <el-col :span="6" style="text-align: left;">
            <div>
              <el-image
                :src="require('./assets/logo.png')"
                style="
                  float: left;
                  width: 45px;
                  height: 45px;
                  margin-left: 10px;
                  margin-right: 10px;
                "
              ></el-image>
              <span>{{ $t('title') }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 宽度小的时候显示这个 -->
      <div class="show-box small">
        <el-row style="margin-bottom: 5px;">
          <el-col :span="11" style="text-align: left;">
            <div>
              <el-image
                :src="require('./assets/logo.png')"
                style="
                  float: left;
                  width: 45px;
                  height: 45px;
                  margin-left: 10px;
                  margin-right: 10px;
                "
              ></el-image>
              <span>{{ $t('title') }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>

    <!-- 主体 -->
    <el-main class="home-main">
      <el-row class="swiper">
        <el-row>{{ $t('swiperText1') }}</el-row>
        <el-row>{{ $t('swiperText2') }}</el-row>
        <el-row style="font-size: 16px; font-weight: 400;">
          {{ $t('swiperText3') }}
        </el-row>
        <el-row>
          <button
            class="download"
            round
            style="width: 156px; height: 41px;"
            @click="goMarket"
          >
            {{ $t('swiperButton') }}
          </button>
        </el-row>
      </el-row>

      <!-- 图片展示区 -->
      <div class="swiperBox">
        <el-row style="text-align: center;">
          <el-row class="swiperBox">
            <el-col
              v-for="(src, index) in srcList"
              :key="index"
              :span="6"
              class="swiperLi"
            >
              <el-image :preview-src-list="srcList" :src="src" class="img-item"></el-image>
            </el-col>
          </el-row>
        </el-row>
      </div>

      <!-- Banner -->
      <!--
      <div>
        <el-image
          :src="require('./assets/BANNER.png')"
          style="
            max-width: 600px;
            width: 100%
            height: auto;
            margin-top: 15px;
            overflow: hidden;
            border-radius: 8px;
            //box-shadow: 0 3px 10px rgba(0,0,0,0.1);
          "
        ></el-image>
      </div>
      -->
    </el-main>

    <!-- 底部 -->
    <el-footer class="footer">
      <div
        style="
          margin-top: 15px;
          padding-top: 15px;
          padding-bottom: 15px;
          border-top: 1px solid rgba(95, 100, 100, 0.15);
          font-size: 15px;
          color: rgba(95, 100, 100, 0.7);
        "
      >
        {{ $t('footerNumber') }}
        <span class="footer-text">
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            style="
              padding-left: 15px;
              padding-right: 15px;
              font-size: 15px;
              color: rgba(95, 100, 100, 0.7);
            "
          >
            {{ $t('footerNumber_icp') }}
          </a>
        </span>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'homePage',
  data() {
    return {
      srcList: [
        require('./assets/guide01.png'),
        require('./assets/guide02.png'),
        require('./assets/guide03.png'),
        require('./assets/guide04.png'),
        require('./assets/guide05.png'),
        require('./assets/guide06.png'),
        require('./assets/guide07.png'),
      ],
      urlManual: 'https://1993hzw.github.io/dragonnest/drawnote/manual/',
    };
  },
  methods: {
    changeLang() {
      this.$i18n.locale =
        this.$i18n.locale === 'en' ? 'cn' : 'en';
      localStorage.setItem('noteLanguage', this.$i18n.locale);
    },

    goMarket() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (!isMobile) {
        alert('请在移动端的应用商店里搜索并下载“吾绘笔记”');
        return;
      }

      const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
      if (isWeChat) {
        alert('请用手机浏览器打开当前页面，或在应用商店里搜索并下载“吾绘笔记”');
        return;
      }

      const ua = navigator.userAgent.toLowerCase();

      const schemes = {
        xiaomi: 'mimarket://details?id=com.dragonnest.drawnote',
        huawei: 'appmarket://details?id=com.dragonnest.drawnote',
        oppo: 'oppomarket://details?pkg=com.dragonnest.drawnote',
        vivo: 'vivomarket://details?id=com.dragonnest.drawnote',
        samsung: 'samsungapps://ProductDetail/com.dragonnest.drawnote',
        google: 'market://details?id=com.dragonnest.drawnote',
      };

      const defaultLink = 'https://m.malink.cn/s/BNz6ba';
      let linkToOpen = defaultLink;

      if (ua.includes('xiaomi')) linkToOpen = schemes.xiaomi;
      else if (ua.includes('huawei') || ua.includes('honor')) linkToOpen = schemes.huawei;
      else if (ua.includes('oppo')) linkToOpen = schemes.oppo;
      else if (ua.includes('vivo')) linkToOpen = schemes.vivo;
      else if (ua.includes('samsung')) linkToOpen = schemes.samsung;
      else if (ua.includes('pixel') || ua.includes('android')) linkToOpen = schemes.google;

      window.location.href = linkToOpen;
    },
  },
};
</script>

<style lang="less" scoped>
/* 响应式布局 */
@media screen and (max-width: 800px) {
  .show-box {
    display: none !important;
  }
  .show-box.small {
    display: block !important;
  }
  .swiper {
    text-align: center !important;
    .el-row {
      &:first-child {
        font-size: 25px !important;
      }
      &:nth-child(2) {
        font-size: 20px !important;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .swiper {
    padding: 30px 30px 5px !important;
  }
  ::v-deep(.swiperLi) {
    flex-basis: 40% !important;
  }
  .footer-text {
    display: block;
    padding-top: 5px;
  }
}
@media screen and (max-width: 500px) {
  .swiper {
    padding: 30px 30px 5px !important;
  }
  ::v-deep(.swiperLi) {
    flex-basis: 40% !important;
  }
  .footer-text {
    display: block;
    padding-top: 5px;
  }
}

/* 头部 */
.head {
  margin-top: 0;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: rgb(51, 51, 51);
  background-color: #fff;

  .show-box {
    display: block;

    &.small {
      display: none;

      .el-button {
        margin-left: 0 !important;
      }
    }

    .el-row {
      display: flex;
      align-items: center;
      height: 48px;
      line-height: 48px;
      padding: 0;

      .head-right {
        float: right;

        a {
          margin-right: 25px;
          font-size: 18px;
          font-weight: bold;
          color: rgb(51, 51, 51);
        }

        .el-button {
          margin: 0 20px 0 10px;
          border-radius: 26px;
          font-size: 13px;
          padding: 5px 15px;
          color: rgb(253, 102, 55);
          border: 1px solid rgb(253, 102, 55);
          background: #fff;
        }
      }

      .head-bottom {
        background-color: #f6f6f6;

        a {
          margin: 0 10px;
          font-size: 15px;
          font-weight: bold;
          color: rgb(51, 51, 51);
        }
      }
    }
  }
}

/* 主体 */
.home-main {
  max-width: 1080px;
  margin: 0 auto;
  text-align: center;

  .swiper {
    text-align: center;
    padding: 30px 30px 5px;

    .el-row {
      margin-bottom: 30px;
      color: rgb(51, 51, 51);
      font-weight: bold;

      &:first-child {
        font-size: 40px;
      }
      &:nth-child(2) {
        font-size: 35px;
      }
    }
  }
}

/* 下载按钮 */
.download {
  color: #fff;
  cursor: pointer;
  max-width: 200px;
  font-weight: 700;
  padding: 10px 30px;
  background: linear-gradient(#009dff, #009dff, #009dff);
  box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.25);
  border-radius: 39px;
  border: 0;

  &:hover {
    transform: scale(1.025);
  }
}

/* 页脚 */
.footer {
  text-align: center;
}

/* 背景图 */
.swiper {
  background: url('./assets/drawnote_bg.png');
  background-size: cover;
}

/* 图片滚动区域 */
.swiperBox {
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
}

/* 每个图片项 */
.swiperLi {
  margin: 5px;
  flex-shrink: 0;
  flex-basis: auto;
  transition: transform 0.2s;
  flex-basis: 22.5%;

  .img-item { border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.1); }
  &:hover {
    transform: scale(1.015);
  }
}

/* 滚动条样式 */
.swiperBox::-webkit-scrollbar {
  height: 2px;
}
.swiperBox::-webkit-scrollbar-track {
  background: transparent;
}
.swiperBox::-webkit-scrollbar-thumb {
  background-color: rgba(150, 150, 150, 0.25);
  border-radius: 4px;
  transition: background-color 0.3s;
}
</style>

<style lang="less">
.download-box {
  .el-row {
    .el-col {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .el-button {
        margin-top: 5px;
        height: 32px;
        padding: 5px;
        color: rgb(253, 102, 55);
        border: 1px solid rgb(253, 102, 55);
        background: #fff;
      }
    }
  }
}

.home-page {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #2c3e50;
}

html,
body,
.el-container {
  padding: 0;
  margin: 0;
  height: 100%;
}

body {
  margin: 8px;
}

.el-header {
  padding-top: 5px !important;
  padding-left: 0px !important;
  height: fit-content !important;
}

.el-main {
  padding: 0 !important;
  overflow: unset !important;
}

a {
  text-decoration: none;
}
</style>
